import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "row border-top bg-white mobileFilterHeaderMenuWrapper" };
const _hoisted_2 = {
    class: "d-inline-block text-left strong",
    style: { "color": "#7a7a7a", "cursor": "pointer" }
};
const _hoisted_3 = { class: "d-inline-block position-relative" };
const _hoisted_4 = {
    class: "overflow-auto bg-white",
    style: { "margin": "10px" }
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = { class: "col-12 mt-3" };
const _hoisted_7 = {
    class: "col-12 py-3 bg-white border-top mt-3",
    style: { "position": "sticky", "bottom": "0", "z-index": "2", "box-shadow": "-7px -4px 10px -8px rgba(0, 0, 0, 0.75)" }
};
const _hoisted_8 = ["onClick"];
const _hoisted_9 = {
    key: 0,
    class: "mobileSortingButton col-6 p-2 border-bottom text-center hoverpointer"
};
const _hoisted_10 = {
    class: "row collapse bg-white",
    id: "SortingCollapse"
};
const _hoisted_11 = { class: "col-12" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_badge = _resolveComponent("v-badge");
    const _component_listing_filters = _resolveComponent("listing-filters");
    const _component_v_dialog = _resolveComponent("v-dialog");
    const _component_filter_sorting = _resolveComponent("filter-sorting");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_dialog, {
                transition: "dialog-top-transition",
                fullscreen: ""
            }, {
                activator: _withCtx(({ props }) => [
                    _createElementVNode("div", _mergeProps(props, {
                        class: ["mobileFilterButton p-2 border-right border-bottom text-center", { 'col-6': !_ctx.isSearch, 'col-12': _ctx.isSearch }]
                    }), [
                        _createElementVNode("div", _hoisted_2, [
                            _cache[1] || (_cache[1] = _createTextVNode(" Filter ", -1)),
                            _createElementVNode("div", _hoisted_3, [
                                _cache[0] || (_cache[0] = _createElementVNode("img", {
                                    src: "/images/icons/funnel.svg",
                                    alt: "Filter"
                                }, null, -1)),
                                (_ctx.appliedFiltersLength != 0)
                                    ? (_openBlock(), _createBlock(_component_v_badge, {
                                        key: 0,
                                        color: "#123646",
                                        content: _ctx.appliedFiltersLength,
                                        style: { "position": "absolute", "top": "5px", "left": "30px" }
                                    }, null, 8, ["content"]))
                                    : _createCommentVNode("", true)
                            ])
                        ])
                    ], 16)
                ]),
                default: _withCtx(({ isActive }) => [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                            onClick: ($event) => (isActive.value = false),
                            class: "col-12 bg-brand_beige_light py-2 text-right",
                            style: { "position": "sticky", "top": "0", "z-index": "2" }
                        }, [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("div", { class: "no-gutters row justify-content-between" }, [
                                    _createElementVNode("h3", { class: "font6 strong mb-0" }, "Produktfilter"),
                                    _createElementVNode("i", { class: "icon-cancel" })
                                ], -1)
                            ]))], 8, _hoisted_5),
                        _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_listing_filters)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("button", {
                                onClick: ($event) => (isActive.value = false),
                                class: "buttonBase buttonGreen w-100"
                            }, "Anwenden", 8, _hoisted_8)
                        ])
                    ])
                ]),
                _: 1
            }),
            (!_ctx.isSearch)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("span", {
                            class: "text-left hoverpointer strong",
                            "data-toggle": "collapse",
                            "data-target": "#SortingCollapse",
                            "aria-expanded": "false",
                            "aria-controls": "SortingCollapse",
                            style: { "color": "#7a7a7a" }
                        }, [
                            _createElementVNode("span", { class: "d-inline-block mr-2" }, "Sortierung"),
                            _createElementVNode("img", {
                                src: "/images/icons/sorting.svg",
                                alt: "Sortierung"
                            })
                        ], -1)
                    ]))]))
                : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_filter_sorting)
            ])
        ])
    ], 64));
}
